<template>
  <header class="header" :class="{ 'scrolled': isScrolled, 'header-hidden': !headerVisible }">
    <div class="header-top">
      <div class="header-container">
        <div class="logo-container">
          <img src="/waplogo.png" alt="研究院标志" class="institute-logo2" />
          <div class="divider"></div>
          <div class="divider"></div>
          <img src="/logo.png" alt="江西财经大学" class="logo" />
          <div class="divider"></div>
          <div class="divider"></div>
          <img src="/in-logo4.png" alt="江西财经大学" class="logo3" />

        </div>

        <div class="right-container">
          <div class="search-login">
            <div class="search-box" :class="{ 'is-focused': isSearchFocused }">
              <el-input placeholder="" v-model="searchText" @focus="isSearchFocused = true" @blur="isSearchFocused = false">
                <template #prefix>
                  <el-icon class="search-icon"><Search /></el-icon>
                </template>
              </el-input>
              <span class="search-options">
                <span class="option" @click="handleSearch" v-show="!searchText">搜索</span>
                <span class="divider">|</span>
                <span class="option" @click="handleFullSiteSearch">全站检索</span>
              </span>
            </div>

            <div class="user-actions">
              <span class="action-text">收藏</span>
              <span class="divider-text">|</span>

              <!-- 未登录 -->
              <span class="action-text" v-if="!auth.isAuthed" @click="navigateToLogin">登录</span>

              <!-- 已登录：头像下拉 -->
              <el-dropdown v-else trigger="click" @command="onUserCommand">
                <div class="user-profile">
                  <!-- <el-avatar :size="30" :src="auth.user?.avatar || '/default-avatar.svg'" class="user-avatar" /> -->
                    <!-- <el-avatar :size="30" :icon="UserFilled" class="user-avatar" /> -->
                    <!-- <el-avatar :size="30" src="/assets/img/user.png" class="user-avatar" /> -->
                       <el-avatar :size="30" :src="avatarImg" class="user-avatar" />
                    
                  <span class="username">{{ auth.user?.username }}</span>
                  <el-icon class="caret"><ArrowDown /></el-icon>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <!-- <el-dropdown-item command="profile">个人中心</el-dropdown-item> -->
                    <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </div>

        <div class="mobile-menu-button" @click="toggleMobileMenu">
          <el-icon class="menu-icon"><Menu /></el-icon>
        </div>
      </div>

      <div class="header-divider"></div>
    </div>

    <nav class="main-nav" :class="{ 'fixed-nav': isScrolled }">
      <ul class="nav-list">
        <!-- 顶部菜单：显示所有条目，但点击时做登录拦截 -->
        <li
          v-for="(item, index) in visibleMenuItems"
          :key="item.id"
          :class="[
            'nav-item',
            {
              active: activeMenuItem === item.id,
              'has-submenu': item.type === 'dropdown' && item.children && item.children.length > 0
            }
          ]"
        >
          <!-- 单页面链接 -->
          <template v-if="item.type === 'single' && item.path">
            <a :href="item.path" @click="onProtectedClick(item, $event)">
              {{ item.title }}
              <el-icon v-if="item.requires_auth && !auth.isAuthed" class="lock"><Lock /></el-icon>
            </a>
          </template>

          <!-- 下拉菜单 -->
          <template v-else-if="item.type === 'dropdown'">
            {{ item.title }}
            <div class="submenu" v-if="item.children && item.children.length > 0">
              <ul>
                <template v-for="(child, childIndex) in item.children" :key="child.id">
                  <li
                    v-if="child.is_visible"
                    :style="{ '--item-index': childIndex }"
                    :class="{ 'active': activeSubMenu === child.id }"
                  >
                    <a :href="child.path" @click="onProtectedClick(child, $event)">
                      {{ child.title }}
                      <el-icon v-if="child.requires_auth && !auth.isAuthed" class="lock"><Lock /></el-icon>
                    </a>
                  </li>
                </template>
              </ul>
            </div>
          </template>
        </li>

        <!-- 移动端更多按钮 -->
        <li class="nav-item mobile-more-button" @click="toggleMobileMenu">
          <el-icon><MoreFilled /></el-icon>
        </li>
      </ul>
    </nav>

    <!-- 移动端抽屉菜单（同样显示全部项，点击时做拦截） -->
    <el-drawer v-model="mobileMenuVisible" direction="rtl" size="80%" :with-header="false" class="mobile-menu-drawer">
      <div class="mobile-menu-header">
        <div class="mobile-user-profile">
           <el-avatar :size="30" :icon="Picture" class="user-avatar" />
          <!-- <el-avatar :size="40" :src="userInfo.avatar || '/default-avatar.svg'" class="user-avatar"></el-avatar> -->
          <span class="username">{{ userInfo.username }}</span>
        </div>
        <el-icon class="close-icon" @click="mobileMenuVisible = false"><Close /></el-icon>
      </div>

      <div class="mobile-search">
        <el-input placeholder="搜索..." v-model="searchText">
          <template #prefix>
            <el-icon class="search-icon"><Search /></el-icon>
          </template>
        </el-input>
      </div>

      <div class="mobile-menu-content">
        <el-menu
          class="mobile-menu"
          background-color="#f5f7fa"
          text-color="#333"
          active-text-color="#5ecbec"
          :default-active="getMobileActiveIndex()"
        >
          <template v-for="(item, index) in menuConfig.menuItems" :key="item.id">
            <!-- 单页面项 -->
            <el-menu-item v-if="item.type === 'single' && item.path" :index="(index + 1).toString()">
              <a :href="item.path" @click="onProtectedClick(item, $event)">
                {{ item.title }}
                <el-icon v-if="item.requires_auth && !auth.isAuthed" class="lock"><Lock /></el-icon>
              </a>
            </el-menu-item>

            <!-- 下拉项 -->
            <el-sub-menu v-else-if="item.type === 'dropdown'" :index="(index + 1).toString()">
              <template #title>{{ item.title }}</template>
              <template v-for="(child, childIndex) in item.children" :key="child.id">
                <el-menu-item
                  v-if="child.is_visible"
                  :index="`${index + 1}-${childIndex + 1}`"
                  :class="{ 'is-active': activeSubMenu === child.id }"
                >
                  <a :href="child.path" @click="onProtectedClick(child, $event)">
                    {{ child.title }}
                    <el-icon v-if="child.requires_auth && !auth.isAuthed" class="lock"><Lock /></el-icon>
                  </a>
                </el-menu-item>
              </template>
            </el-sub-menu>
          </template>
        </el-menu>
      </div>

      <div class="mobile-menu-footer">
        <div class="mobile-user-actions">
          <span>收藏</span>
          <span class="divider-text">|</span>
          <span v-if="!auth.isAuthed" @click="navigateToLoginMobile">登录</span>
          <span v-else class="flex items-center">
            <el-avatar :size="24" :src="auth.user?.avatar || '/default-avatar.svg'" style="margin-right:8px" />
            {{ auth.user?.username }}
            <el-button link type="danger" @click="handleLogout" style="margin-left:8px">退出</el-button>
          </span>
        </div>
      </div>
    </el-drawer>
  </header>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed, reactive } from 'vue'
import { Search, Menu, MoreFilled, Close, ArrowDown, Lock, Picture } from '@element-plus/icons-vue'
import { useRoute } from 'vue-router'
import router from '@/router'
import { useAuthStore } from '@/stores/auth'
import { ElMessageBox, ElMessage } from 'element-plus'
import { UserFilled } from '@element-plus/icons-vue'
import avatarImg from '@/assets/img/user.png';
import { logout as apiLogout } from '@/utils/api/login' 
// 登录跳转
const navigateToLogin = () => router.push('/login')
const navigateToLoginMobile = () => {
  mobileMenuVisible.value = false
  router.push('/login')
}

// 登录状态
const auth = useAuthStore()

// 统一点击拦截：需要登录的项在未登录时弹框，否则正常跳转
const onProtectedClick = (
  node: { path: string; requires_auth?: boolean },
  e: Event
) => {
  e.preventDefault()
  if (node.requires_auth && !auth.isAuthed) {
    ElMessageBox.confirm('该内容仅登录后可访问，是否前往登录？', '请先登录', {
      type: 'warning',
      confirmButtonText: '去登录',
      cancelButtonText: '取消'
    })
      .then(() => {
        router.push({ path: '/login', query: { redirect: node.path } })
      })
      .catch(() => {})
    return
  }
  router.push(node.path)
}

// 头像下拉：退出登录
const onUserCommand = async (cmd: string) => {
  if (cmd === 'logout') await handleLogout()
  else if (cmd === 'profile') router.push('/profile')
}


const handleLogout = async () => {
  try {
    await ElMessageBox.confirm('确定要退出登录吗？', '提示', { type: 'warning' })

    console.log('calling /common/logout ...') // ✅ 用来确认是否执行到这一步

    // 先通知后端（此时 token 还在，axios 才能带 Authorization）
    try {
      const res = await apiLogout()
      console.log('logout api response:', res)
      // res.code 不是 1 也没关系，退出流程继续
    } catch (e) {
      console.warn('logout api failed (ignored):', e)
    }

  } catch {
    // 用户取消
    return
  } finally {
    // 无论如何都清理本地
    auth.logout()
    ElMessage.success('已退出登录')
    router.replace('/login')
  }
}

// ====== 菜单与布局 ======
interface SingleMenuItem {
  id: string
  title: string
  path: string
  is_visible: boolean
  type: 'single'
  requires_auth?: boolean
}
interface DropdownMenuItem {
  id: string
  title: string
  type: 'dropdown'
  requires_auth?: boolean
  children: Array<{
    id: string
    title: string
    path: string
    is_visible: boolean
    requires_auth?: boolean
  }>
}
type MenuItem = SingleMenuItem | DropdownMenuItem
interface MenuConfig { menuItems: MenuItem[] }

const route = useRoute()
const searchText = ref('')
const isSearchFocused = ref(false)
const isScrolled = ref(false)
const lastScrollTop = ref(0)
const headerVisible = ref(true)
const headerTopHeight = ref(0)
const scrollThreshold = 5
let scrollTimer: number | null = null

const mobileMenuVisible = ref(false)
const isMobileView = ref(false)
const visibleNavItems = ref(6)

const menuConfig = reactive<MenuConfig>({ menuItems: [] })

const loadMenuConfig = async () => {
  try {
    const response = await fetch('/menu-config.json')
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
    const config = await response.json()
    menuConfig.menuItems = config.menuItems || []
  } catch (error) {
    console.error('加载菜单配置失败:', error)
    menuConfig.menuItems = [
      { id: 'home', title: '首页', path: '/', is_visible: true, type: 'single' }
    ]
  }
}

// 显示菜单：不做权限过滤，只做响应式裁剪数量
const visibleMenuItems = computed(() => menuConfig.menuItems.slice(0, visibleNavItems.value))

const activeMenuItem = computed(() => {
  const path = route.path
  if (path === '/' || path === '/home') return 'home'
  for (const item of menuConfig.menuItems) {
    if (item.type === 'single' && item.path === path) return item.id
    if (item.type === 'dropdown' && item.children) {
      for (const child of item.children) {
        if (path === child.path) return item.id
      }
    }
  }
  return ''
})

const activeSubMenu = computed(() => {
  const path = route.path
  for (const item of menuConfig.menuItems) {
    if (item.type === 'dropdown' && item.children) {
      for (const child of item.children) {
        if (path === child.path) return child.id
      }
    }
  }
  return ''
})

const getMobileActiveIndex = () => {
  const currentItem = activeMenuItem.value
  const itemIndex = menuConfig.menuItems.findIndex(item => item.id === currentItem)
  return itemIndex >= 0 ? (itemIndex + 1).toString() : '1'
}

const toggleMobileMenu = () => {
  mobileMenuVisible.value = !mobileMenuVisible.value
}

const checkWindowSize = () => {
  isMobileView.value = window.innerWidth <= 768
  const total = menuConfig.menuItems.length
  if (window.innerWidth < 480)      visibleNavItems.value = Math.min(1, total)
  else if (window.innerWidth < 576) visibleNavItems.value = Math.min(2, total)
  else if (window.innerWidth < 768) visibleNavItems.value = Math.min(3, total)
  else if (window.innerWidth < 992) visibleNavItems.value = Math.min(7, total)
  else if (window.innerWidth < 1200)visibleNavItems.value = Math.min(8, total)
  else if (window.innerWidth < 1400)visibleNavItems.value = Math.min(8, total)
  else                               visibleNavItems.value = total
}

const userInfo = ref({ username: '用户名', avatar: '' })

const handleScroll = () => {
  let t: ReturnType<typeof setTimeout> | null = null
  if (t) clearTimeout(t)
  t = setTimeout(() => {
    const current = window.scrollY || document.documentElement.scrollTop
    const down = current > lastScrollTop.value + scrollThreshold
    const up   = current < lastScrollTop.value - scrollThreshold
    if (Math.abs(current - lastScrollTop.value) > scrollThreshold) {
      lastScrollTop.value = current <= 0 ? 0 : current
    }
    if (current > headerTopHeight.value) {
      isScrolled.value = true
      if (down && current > headerTopHeight.value + 100) headerVisible.value = false
      else if (up) headerVisible.value = true
    } else {
      isScrolled.value = false
      headerVisible.value = true
    }
  }, 10)
}

const handleSearch = () => { console.log('搜索:', searchText.value) }
const handleFullSiteSearch = () => { console.log('全站检索') }

onMounted(async () => {
  auth.initFromStorage() // 恢复登录态
  await loadMenuConfig()

  setTimeout(() => {
    const headerContainer = document.querySelector('.header-container')
    const headerDivider = document.querySelector('.header-divider')
    const mainNav = document.querySelector('.main-nav')
    if (headerContainer && headerDivider) {
      headerTopHeight.value =
        (headerContainer as HTMLElement).offsetHeight + (headerDivider as HTMLElement).offsetHeight
    }
    if (mainNav) {
      const navHeight = (mainNav as HTMLElement).offsetHeight
      document.documentElement.style.setProperty('--nav-height', `${navHeight}px`)
    }
  }, 50)

  window.addEventListener('scroll', handleScroll, { passive: true })
  window.addEventListener('resize', checkWindowSize)
  checkWindowSize()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  window.removeEventListener('resize', checkWindowSize)
})
</script>

<style scoped>
/* 新增的移除焦点轮廓规则 */
a:focus { outline: none; }
.el-menu-item:focus, .el-sub-menu:focus, .el-menu-item:focus-visible, .el-sub-menu:focus-visible { outline: none; }

.header {
  width: 100%;
  background: linear-gradient(to bottom, #5f95c0, #7bb2d4, #9acfe7);
  position: relative;
  z-index: 1002;
  transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1), box-shadow 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  will-change: transform, opacity;
}
.header.scrolled { position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; box-shadow: 0 2px 10px rgba(0,0,0,0.1); z-index: 1001; transform: translateZ(0); }
.header.header-hidden { transform: translateY(-100%); }

.header-top { background: linear-gradient(to bottom, #5f95c0, #7bb2d4); padding: 0; width: 100%; }
.header-container { display: flex; justify-content: space-between; align-items: center; padding: 10px 50px; max-width: 1200px; margin: 0 auto; width: 100%; height: 70px; }
@media (max-width:1440px){ .header-container{ max-width: 1000px; } }
@media (max-width:1280px){ .header-container{ max-width: 1000px; } }

.logo-container { margin-left: -12%; display: flex; align-items: center; }
.logo, .institute-logo { height: 50px; }
.logo3{ height: 40px; }
.institute-logo2 { height: 40px; margin-top: 10px; }
.divider { width: 0.1px; height: 42px; color: black; margin: 0 3px; }

.right-container { display: flex; justify-content: flex-end; }
.search-login { display: flex; align-items: center; gap: 30px; margin-right: -30%; }

.search-box { display: flex; align-items: center; background-color: #a6cae1; border-radius: 25px; overflow: hidden; padding-right: 10px; box-shadow: 0 3px 10px rgba(0,0,0,0.1); transition: all 0.3s ease; width: 220px; border: 1px solid rgba(255,255,255,0.3); }
.search-box :deep(.el-input__wrapper){ background-color:#a6cae1; box-shadow:none; padding-right:0; border-radius:25px; }
.search-box :deep(.el-input__inner){ height:36px; font-size:14px; border-radius:25px; padding-left:5px; color:#333; }
.search-box :deep(.el-input__inner::placeholder){ color:#999; }
.search-options { margin-left: 5px; color: black; font-size: 14px; white-space: nowrap; padding: 0 10px; cursor: pointer; }
.search-box:hover { box-shadow: 0 5px 15px rgba(0,0,0,0.15); transform: translateY(-2px); }
.search-box.is-focused { width: 280px; box-shadow: 0 5px 20px rgba(0,0,0,0.2); }
.search-icon { color:#666; transition: all 0.3s ease; }
.search-box:hover .search-icon, .search-box.is-focused .search-icon { color:#1e4b78; transform: scale(1.1); }

.user-actions { display: flex; align-items: center; gap: 10px; color: black; font-size: 14px; cursor: pointer; }
.divider-text { color: #4c5c6c; }
.user-avatar { margin-left: 1px; }
.user-profile { display: flex; align-items: center; gap: 5px; margin-left: 15px; cursor: pointer; }
.user-profile:focus { outline: none !important; box-shadow: none !important; }
.user-profile .el-icon.caret:focus { outline: none !important; }
.username { font-size: 14px; color: black; }

:deep(.el-dropdown-menu__item){ outline:none !important; }
:deep(.el-dropdown-menu__item:focus){ background-color: transparent !important; outline:none !important; }

.header-divider { width: 90%; height: 1px; background-color: #4c5c6c; margin: 0 auto; }

.main-nav { background: linear-gradient(to bottom, #7bb2d4, #9acfe7); padding: 0; position: relative; transition: all 0.4s cubic-bezier(0.215,0.61,0.355,1); z-index: 1002; height: 52px; color: black; will-change: transform, box-shadow; }
.main-nav.fixed-nav { position: fixed !important; top:0 !important; left:0 !important; width:100% !important; box-shadow: 0 2px 15px rgba(0,0,0,0.1); transform: translateY(0) translateZ(0); animation: slideDown 0.4s cubic-bezier(0.215,0.61,0.355,1); animation-fill-mode: both; backface-visibility: hidden; }
@keyframes slideDown { from{ transform: translateY(-100%) translateZ(0); opacity: .8; } to{ transform: translateY(0) translateZ(0); opacity: 1; } }

.nav-list { display:flex; list-style:none; margin:0; padding:0; max-width:1200px; margin:0 auto; justify-content: space-between; height:50px; }
.nav-item { color:black; padding: 15px 30px; cursor:pointer; font-size:16px; transition: all .3s ease; position:relative; transform-style:preserve-3d; perspective:1000px; }
.nav-item::after { content:''; position:absolute; bottom:0; left:50%; width:0; height:3px; background-color:white; transition: all .3s cubic-bezier(0.4,0,0.2,1); transform: translateX(-50%); }
.nav-item:hover::after, .nav-item.active::after { width:100%; }
.nav-item:hover, .nav-item.active { background-color: rgba(255,255,255,.2); transform: scale(1.05) rotateX(5deg); text-shadow: 0 2px 4px rgba(0,0,0,.2); color:white; font-weight:bold; }

.has-submenu { position:relative; }
.submenu { position:absolute; top:100%; left:0; width:123px; background:#d2e4f2; box-shadow:0 10px 20px rgba(0,0,0,.15); opacity:0; visibility:hidden; transform: translateY(-15px) perspective(600px) rotateX(-5deg); transform-origin: top center; transition: opacity .4s cubic-bezier(0.215,0.61,0.355,1), transform .4s cubic-bezier(0.215,0.61,0.355,1), visibility .4s cubic-bezier(0.215,0.61,0.355,1); z-index:1001; backdrop-filter: blur(2px); border:1px solid rgba(255,255,255,.2); }
.has-submenu:hover .submenu { opacity:1; visibility:visible; transform: translateY(0) perspective(600px) rotateX(0); }

.submenu ul { list-style:none; padding:0; margin:0; background:transparent; }
.submenu ul li { padding:12px 10px; color:#222; font-size:14px; transition: all .3s ease; cursor:pointer; position:relative; overflow:hidden; opacity:0; transform: translateY(10px); text-align:center; animation: fadeInUp .4s forwards; animation-delay: calc(0.05s * var(--item-index, 0)); background:transparent; font-weight:normal; }
.submenu ul li::after{ content:''; position:absolute; bottom:0; left:10%; width:70%; height:1px; background-color: rgba(95,186,214,.752); }
.submenu ul li:last-child{ border-bottom:none; }
.submenu ul li:hover, .submenu ul li.active { background-color: rgba(94,203,236,.3); color:#333; font-weight:bold; }
.submenu ul li::before{ content:''; position:absolute; left:0; top:0; height:100%; width:3px; background-color:#5ecbec; transform: scaleY(0); transition: transform .3s ease; }
.submenu ul li:hover::before, .submenu ul li.active::before{ transform: scaleY(1); }

@keyframes fadeInUp { from{ opacity:0; transform: translateY(10px); } to{ opacity:1; transform: translateY(0); } }

.header.scrolled .header-top{ display:none; }
.header.header-hidden .header-top{ transform: translateY(-100%); }
.header.header-hidden .main-nav{ position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; }

.mobile-menu-button { display:none; width:40px; height:40px; background-color: rgba(255,255,255,.2); border-radius:50%; justify-content:center; align-items:center; cursor:pointer; transition: all .3s ease; position:relative; z-index:1005; }
.mobile-menu-button:hover { background-color: rgba(255,255,255,.3); }
.menu-icon{ font-size:24px; color:white; }

.mobile-more-button { display:none; font-size:24px; padding:10px 15px; margin-left:auto; color:white; align-items:center; justify-content:center; background-color: rgba(255,255,255,.2); border-radius:50%; width:40px; height:40px; cursor:pointer; position:relative; z-index:1005; }
.mobile-more-button:hover { background-color: rgba(255,255,255,.3); }

.mobile-menu-drawer { background-color: #f5f7fa; width:100%; }
.mobile-menu-drawer :deep(.el-drawer__body){ padding:0; display:flex; flex-direction:column; height:100%; }
.mobile-menu-header { padding:20px; background: linear-gradient(to bottom, #5f95c0, #7bb2d4); display:flex; justify-content:space-between; align-items:center; }
.mobile-user-profile { display:flex; align-items:center; gap:15px; }
.mobile-user-profile .username{ font-size:16px; font-weight:500; }
.close-icon{ font-size:22px; color:white; cursor:pointer; }

.mobile-search{ padding:15px; border-bottom:1px solid #eee; }
.mobile-menu-content{ flex:1; overflow-y:auto; }
.mobile-menu{ border-right:none; }
.mobile-menu .el-menu-item, .mobile-menu .el-sub-menu__title{ height:50px; line-height:50px; }

.mobile-menu-footer{ padding:15px; border-top:1px solid #eee; }
.mobile-user-actions{ display:flex; justify-content:center; gap:20px; color:#666; }

@media (max-width:1200px){ .logo-container{ margin-left:0; } .search-login{ margin-right:0; } .header-container{ padding:10px 20px; } .nav-item{ padding:15px 20px; } }
@media (max-width:992px){ .nav-item{ padding:15px 15px; font-size:14px; } .search-box{ width:180px; } .search-options{ display:none; } .user-actions .action-text{ display:none; } .user-actions .divider-text{ display:none; } }
@media (max-width:768px){
  .mobile-menu-button{ display:flex; }
  .mobile-more-button{ display:flex; position:absolute; right:20px; margin-left:auto; }
  .header-container{ justify-content:space-between; height:60px; }
  .logo, .institute-logo{ height:40px; }
  .right-container{ display:none; }
  .nav-item:nth-child(n+4){ display:none; }
  .nav-item{ padding:15px 10px; font-size:13px; }
  .nav-list{ position:relative; justify-content:flex-start; }
}
@media (max-width:576px){
  .nav-item:nth-child(n+3){ display:none; }
  .logo-container .divider, .logo-container .institute-logo{ display:none; }
  .header-container{ padding:10px 15px; height:50px; }
  .logo{ height:35px; }
}
@media (max-width:480px){
  .nav-item:nth-child(n+2){ display:none; }
  .nav-list{ justify-content:space-between; }
}

.nav-item a, .submenu ul li a, .el-menu-item a {
  color: inherit; text-decoration: none; display: block; width: 100%; height: 100%; position: relative; z-index: 10;
}

.submenu ul li.active{ background-color: rgba(94,203,236,.3); color:#333; }
.submenu ul li.active::before{ transform: scaleY(1); }
.submenu ul li.active a{ color:#1e4b78; font-weight:bold; }

.lock { margin-left: 6px; }
.lock { display: none !important; }

</style>
